<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'slim combineren',
  }"
>
  <ng-template #content>
    @if (orderContent().crossSellUseNewDesign) {
      @if (thuisvoordeelAddonEnabled()) {
        <div [class.mb-3]="mainProductShown">
          <crnt-radio-group class="cross-sell-radio-group">
            <crnt-form-control-label slot="legend">{{
              orderContent().thuisvoordeelCardContentTitle
            }}</crnt-form-control-label>

            @if (formState().controls.hasSelectedLoyaltyProgram | isInvalid) {
              @if (
                formState().controls.hasSelectedLoyaltyProgram.errors[
                  'required'
                ]
              ) {
                <crnt-form-control-validation-message>
                  {{ orderContent().crossSellInputRequiredError }}
                </crnt-form-control-validation-message>
              }
            }

            <label
              for="hasSelectedLoyaltyProgram-none"
              class="radio-control hover-darken border-primary"
              [class.checked]="
                formState().value.hasSelectedLoyaltyProgram === false
              "
            >
              <div class="d-flex align-items-center">
                <input
                  type="radio"
                  id="hasSelectedLoyaltyProgram-none"
                  class="me-1"
                  selected="false"
                  [value]="false"
                  [ngrxFormControlState]="
                    formState().controls.hasSelectedLoyaltyProgram
                  "
                />
                <span class="fw-bold m-0">
                  {{ orderContent().thuisvoordeelNoOptionLabel }}
                </span>
              </div>
            </label>

            <div class="border-primary">
              <label
                for="hasSelectedLoyaltyProgram-yes"
                class="radio-control hover-darken"
                [class.checked]="formState().value.hasSelectedLoyaltyProgram"
              >
                <div class="d-flex align-items-center">
                  <input
                    type="radio"
                    id="hasSelectedLoyaltyProgram-yes"
                    class="me-1"
                    [value]="true"
                    [ngrxFormControlState]="
                      formState().controls.hasSelectedLoyaltyProgram
                    "
                  />
                  <span class="fw-bold m-0">
                    {{ orderContent().thuisvoordeelYesOptionLabel }}
                  </span>
                </div>
              </label>
              <crnt-button
                type="button"
                variant="tertiary"
                class="radio-control__more-info"
                [fullWidth]="true"
                (click)="onLoyaltyMoreInfoClick($event)"
              >
                {{ orderContent().thuisvoordeelInfoModalLink }}
              </crnt-button>
            </div>
          </crnt-radio-group>
        </div>
      }

      @if (mainProductShown) {
        <crnt-radio-group class="cross-sell-radio-group">
          <crnt-form-control-label slot="legend">{{
            orderContent().crossSellCardContentTitle
          }}</crnt-form-control-label>

          @if (formState().controls.hasSelectedProduct | isInvalid) {
            @if (formState().controls.hasSelectedProduct.errors['required']) {
              <crnt-form-control-validation-message>
                {{ orderContent().crossSellInputRequiredError }}
              </crnt-form-control-validation-message>
            }
          }

          <label
            for="hasSelectedProduct-none"
            class="radio-control hover-darken border-primary"
            [class.checked]="formState().value.hasSelectedProduct === false"
          >
            <div class="d-flex align-items-center">
              <input
                type="radio"
                id="hasSelectedProduct-none"
                class="me-1"
                selected="false"
                [value]="false"
                [ngrxFormControlState]="formState().controls.hasSelectedProduct"
              />
              <span class="fw-bold m-0">
                {{ orderContent().crossSellNoOptionLabel }}
              </span>
            </div>
            <div>
              <span class="fw-bold">+ {{ 0 | euroCurrency: '1.0-2' }}</span>
              {{ orderContent().crossSellMonthlyShort }}
            </div>
          </label>

          <div class="border-primary">
            <label
              for="hasSelectedProduct-product"
              class="radio-control hover-darken"
              [class.checked]="formState().value.hasSelectedProduct"
            >
              <div class="d-flex align-items-center">
                <input
                  type="radio"
                  id="hasSelectedProduct-product"
                  class="me-1"
                  [value]="true"
                  [ngrxFormControlState]="
                    formState().controls.hasSelectedProduct
                  "
                />
                <span class="fw-bold m-0">
                  {{ product().content.longTitle }}
                </span>
              </div>
              <div class="subtext">
                <span class="fw-bold"
                  >+ {{ product().price | euroCurrency: '1.0-2' }}</span
                >
                {{ orderContent().crossSellMonthlyShort }}
              </div>
            </label>
            <crnt-button
              type="button"
              variant="tertiary"
              class="radio-control__more-info"
              [fullWidth]="true"
              (click)="onMoreInfoClick($event)"
            >
              {{ orderContent().crossSellInfoModalLink }}
            </crnt-button>
          </div>
        </crnt-radio-group>
      }
    } @else {
      <div
        class="cross-sell-card"
        [class.checked]="formState().value.hasSelectedProduct"
        (click)="onCardClick($event)"
        (keydown.Space)="onCardClick($event)"
      >
        <div class="cross-sell-card__header">
          <h4 class="h3">{{ product().content.longTitle }}</h4>
          <span>
            <strong>+ {{ product().price | euroCurrency: '1.0-2' }}</strong>
            {{ orderContent().crossSellMonthlyShort }}
          </span>
        </div>
        <div class="cross-sell-card__body">
          <p *wlGenericRichText="product().content?.longSubtitle"></p>
        </div>
        <wl-generic-usps [usps]="usps()" />
        <div class="cross-sell-card__footer">
          <button
            type="button"
            class="p-0 btn btn-link text-primary"
            (click)="onMoreInfoClick($event)"
            (keydown.Space)="onMoreInfoClick($event)"
          >
            <span>{{ orderContent().crossSellInfoModalLink }}</span>
            <crnt-icon icon="chevron-right" class="ms-1"></crnt-icon>
          </button>
          <div class="form-check form-check-reverse cross-sell-card__check">
            <label class="form-check-label" for="selectProduct">
              {{
                formState().value.hasSelectedProduct
                  ? orderContent().crossSellAddedLabel
                  : orderContent().crossSellAddLabel
              }}
            </label>
            <input
              id="selectProduct"
              name="selectProduct"
              [ngrxFormControlState]="formState().controls.hasSelectedProduct"
              type="checkbox"
              class="form-check-input"
              wlHasValueClass="has-value"
              [ngrxEnableFocusTracking]="true"
              (click)="$event.stopPropagation()"
              (keydown.Space)="$event.stopPropagation()"
            />
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #summary>
    <div class="cross-sell-summary">
      @if (
        !formState().value.hasSelectedProduct &&
        !formState().value.hasSelectedLoyaltyProgram
      ) {
        <p class="product-title">
          {{ orderContent().crossSellNoProductSelectedTitle }}
        </p>
        <p class="product-subtitle">
          {{ orderContent().crossSellNoProductSelectedSubtitle }}
        </p>
      } @else {
        <div class="d-flex flex-column gap-2">
          @if (formState().value.hasSelectedLoyaltyProgram) {
            <div>
              <p class="product-title">
                {{ orderContent().thuisvoordeelSummaryTitle }}
              </p>
              <p class="product-subtitle">
                {{ orderContent().thuisvoordeelSummarySubtitle }}
              </p>
            </div>
          }
          @if (formState().value.hasSelectedProduct) {
            <div>
              <p class="product-title">{{ product().content.longTitle }}</p>
              <p class="product-subtitle">
                <span *wlGenericRichText="product().content.longSubtitle"></span
                ><span>
                  (+ {{ product().price | euroCurrency: '1.0-2' }}
                  {{ orderContent().crossSellMonthlyShort }})</span
                >
              </p>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</wl-simple-progressive-form-card>
